import type { Ceviri } from "../tip";
import type { hesaplar as tr } from "../tr/hesaplar";

/** English dictionary · hesaplar. */
export const hesaplar: Ceviri<typeof tr> = {
  renk: {
    mavi: "Blue",
    lacivert: "Navy",
    mor: "Purple",
    eflatun: "Lilac",
    turkuaz: "Turquoise",
    petrol: "Teal",
    kahverengi: "Brown",
    gri: "Grey",
  },

  secici: {
    hesap: "Account",
    butunKasaGercek: "Whole vault (real accounts)",
    hesaplar: "Accounts",
    sanalHesaplar: "Virtual accounts",
    sanalEk: (ad) => `${ad} (virtual)`,
    sanal: "(virtual)",
    butunKasa: "Whole vault",
    birHesap: "1 account",
    karsilastiriliyor: (n) => `Comparing ${n} accounts`,
    aciklama: (enCok) =>
      `If none is ticked: the whole vault. Two or more ticked accounts are compared as separate lines (at most ${enCok}).`,
    kapat: "Close",
  },

  ekran: {
    baslik: "Accounts",
    aciklama: "The brokers, banks and wallets your transactions belong to.",
    hesapEkle: "Add account",
    yeniHesap: "New account",
    ucretsizSinir: (n) => `Free use allows at most ${n} active ${n === 1 ? "account" : "accounts"}.`,
    oksuzBaslik: "Some transactions belong to deleted accounts",
    oksuzMetin:
      "These transactions still count in reports and totals. For each, you can delete the transactions or move them to another account.",
    oksuzSatir: (n) => `(deleted account) — ${n} ${n === 1 ? "transaction" : "transactions"}`,
    coz: "Resolve…",
    yukleniyor: "Loading accounts…",
    bosBaslik: "No accounts yet",
    bosYedekli:
      "Define at least one account before entering transactions. If you used Parafon on another device, you can restore your vault from the cloud.",
    bos: "You need to define at least one account before entering transactions.",
    ilkHesap: "Add first account",
    buluttanGeriYukle: "Restore from cloud",
    tabloBaslik: "Defined accounts",
    sutun: {
      ad: "Name",
      tur: "Type",
      kurum: "Institution",
      paraBirimi: "Currency",
      acilis: "Opened",
      kapanis: "Closed",
      islem: "Actions",
    },
    devreDisi: "disabled",
    saltOkunur: "read-only",
    taninmayanKod: (kod) =>
      `"${kod}" is not a recognised currency code; exchange rates for this account's transactions cannot be found. Edit the account and pick a code from the list.`,
    tekrarAcIpucu: "The account and its transactions become visible everywhere again.",
    devreDisiIpucu: "The account and its transactions are hidden outside this page and left out of totals. Nothing is deleted.",
    tekrarAc: "Re-enable",
    devreDisiBirak: "Disable",
    hesabiDuzenle: "Edit account",
    silBaslik: "Delete account?",
    silSonEk:
      " will be removed from the list. The record is not physically deleted but marked as deleted (tombstone) — needed so the sync layer can carry the deletion to other devices.",
    hareketYok: "No transactions belong to this account.",
    tasiVeSil: "Move and delete",
    cozBaslik: "Transactions of a deleted account",
    cozSonEk: "account was deleted but its transactions remain.",
    tasi: "Move",
    hareketleriSil: "Delete transactions",
  },

  form: {
    adZorunlu: "Account name is required.",
    paraBirimiSecin: "Pick a currency from the list.",
    kapanisOnce: "Closing date cannot be before opening date.",
    sinirDoldu: "Account limit reached; new accounts come with a Subscription.",
    hesapAdi: "Account name",
    hesapTuru: "Account type",
    kurum: "Institution",
    kurumIpucu: "Broker or bank name. Free text.",
    anaParaBirimi: "Main currency",
    paraBirimiIpucu: "Transactions may be in other currencies.",
    acilisTarihi: "Opening date",
    kapanisTarihi: "Closing date",
    renk: "Colour",
    renkAciklama: "The account name appears in this colour. Amounts and warnings are not coloured.",
    hesapRengi: "Account colour",
    renksiz: "No colour",
    not: "Note",
  },

  duzenlenebilir: {
    bolum: "Editable accounts",
    ne: (n) => `Editing more than ${n} ${n === 1 ? "account" : "accounts"}`,
    aciklama: (n) =>
      `Your accounts were not deleted and still appear in reports; pick the ${n} ${n === 1 ? "account" : "accounts"} to keep editable, the rest become read-only.`,
    secimiKaydet: "Save selection",
  },
};
